// src/components/projects/ProjectAdvisorCard/ProjectAdvisorCard.jsx
import React from "react";
import whatsappLink from "../../utils/whatsappLink";
import {
  FiPhoneCall,
  FiMessageCircle,
  FiMail,
  FiArrowUpRight,
} from "react-icons/fi";
import "./ProjectAdvisorCard.css";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";

export default function ProjectAdvisorCard({ advisor, id }) {
  const addClick = async (call) => {
    const data = {
      url: apis().lisitingAddClick + "?id=" + id,
      method: "PUT",
    };
    await httpAction(data);

    if (call === "call") {
      window.location.href = `tel:${advisor?.mobile}`;
    }

    if (call === "whatsapp") {
      window.location.href = whatsappLink(
        advisor?.mobile,
        "Hello iam intrested in this project",
        window.location.href
      );
    }

    if (call === "paymentPlan") {
      window.location.href = whatsappLink(
        advisor?.mobile,
        "Hello please send me payment plan of this project",
        window.location.href
      );
    }
  };

  return (
    <aside className="pac">
      <div className="pac__card">
        <div className="pac__top">
          <img
            className="pac__img"
            src={apis().localUrl + advisor?.imageUrl}
            alt={advisor?.name}
          />
          <div>
            <div className="pac__name">{advisor?.name}</div>
            <div className="pac__role">{advisor?.desigination}</div>
            <div className="pac__meta">
              {advisor?.experience} Year + Experience
            </div>
          </div>
        </div>

        <div className="pac__row">
          <a className="pac__action" onClick={() => addClick("call")}>
            <FiPhoneCall /> Call
          </a>
          <a className="pac__action" onClick={() => addClick("whatsapp")}>
            <FiMessageCircle /> WhatsApp
          </a>
          {/* <a className="pac__action" href={`mailto:${advisor.email}`}>
            <FiMail /> Email
          </a> */}
        </div>

        <button
          onClick={() => addClick("paymentPlan")}
          className="pac__cta"
          type="button"
        >
          Get Payment Plan <FiArrowUpRight />
        </button>

        <div className="pac__hint">
          Share your budget + preferred unit type. We’ll suggest the best
          options.
        </div>
      </div>
    </aside>
  );
}
